interface IconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

export function ExpandIcon({ size = 24, color, className }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="currentColor"
      style={color ? { color } : undefined}
      className={className}
      aria-hidden="true"
    >
      <path d="M9.21875 5.71875C8.925 6.0125 8.925 6.4875 9.21875 6.77812C9.5125 7.06875 9.9875 7.07187 10.2781 6.77812L14.4969 2.55938V5.25C14.4969 5.66563 14.8313 6 15.2469 6C15.6625 6 15.9969 5.66563 15.9969 5.25V0.75C15.9969 0.334375 15.6625 0 15.2469 0H10.75C10.3344 0 10 0.334375 10 0.75C10 1.16562 10.3344 1.5 10.75 1.5H13.4406L9.21875 5.71875ZM6.78125 10.2812C7.075 9.9875 7.075 9.5125 6.78125 9.22188C6.4875 8.93125 6.0125 8.92813 5.72188 9.22188L1.5 13.4406V10.75C1.5 10.3344 1.16562 10 0.75 10C0.334375 10 0 10.3344 0 10.75V15.25C0 15.6656 0.334375 16 0.75 16H5.25C5.66563 16 6 15.6656 6 15.25C6 14.8344 5.66563 14.5 5.25 14.5H2.55938L6.78125 10.2812Z" />
    </svg>
  );
}
